// extracted by mini-css-extract-plugin
export default {"phone":"EligibilityNotification_phone__Trh3r","desktopOnly":"EligibilityNotification_desktopOnly__HdVWl","mobileOnly":"EligibilityNotification_mobileOnly__xcLwl"};